import styled from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ControlsGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: "toggle dropdowns options";
  column-gap: 16px;
  row-gap: 16px;
  align-items: end;

  ${mediaMax.desktop} {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "toggle options"
      "dropdowns dropdowns";
  }
`;

export const ToggleCell = styled.div`
  grid-area: toggle;
`;

export const DropdownsCell = styled.div`
  grid-area: dropdowns;
  display: flex;
  gap: 16px;
`;

export const OptionsCell = styled.div`
  grid-area: options;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
